import React from "react";
import styles from './hashtag.module.css'
const Hashtag=()=>{
    return(
        <div className={styles.container}>
            <div className={styles.header}>
            <h1>#rock_n_roll</h1>
            <div>24 Posts | 5 follower</div>
            <br/>
            <button className="followbtn">Follow</button>
            </div>
            <div className={styles.main}>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>
                <div>
                    <img alt="hah" src="https://venngage-wordpress.s3.amazonaws.com/uploads/2018/09/Mountain-Landscape-Simple-Nature-Background-Image.jpg" />
                </div>


            </div>
        </div>
    )
}


export default Hashtag